export default __webpack_public_path__ + "static/media/SteffanyNaranjoV.5945edce.pdf";